import { DatePipe } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import { BalanceVO } from 'src/app/shared/models/BalanceVO';
import { GuideModel } from 'src/app/shared/models/guide-model';
import { ItemsCurrentPriceVO } from 'src/app/shared/models/ItemsCurrentPriceVO';
import { PurchDowloadsVO } from 'src/app/shared/models/PurchDowloadsVO';
import { ResponseFile } from 'src/app/shared/models/ResponseFile';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { AuthenticationService } from 'src/app/_services';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { ItemsTrack } from 'src/app/shared/models/ItemsTrack';
import { GenericMessageVO } from 'src/app/shared/models/GenericMessageVO';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { Constants } from 'src/app/shared/vo/Constants';

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ShopComponent implements OnInit {

  transactionId = 'dwdAV';

  lbl_select: string = "select_";
  lbl_type: string = "type_";
  lbl_photo: string = "photo_";
  lbl_name: string = "name_";
  lbl_guide: string = "guide_";
  lbl_there_are: string = "there_are_";
  lbl_item: string = "item_";
  lbl_search: string = "search_";
  lbl_track: string = "track_";
  lbl_go_Back: string = "back_";
  lbl_language: string = "language_";

  sortOptions: any[];
  items: ValuesVO[];
  selectedItem: ItemsCurrentPriceVO;
  token: string;
  security: SecurityDocument;
  sortOrder: number;
  sortField: string;
  imageSrc: string = '';
  selectedFileName?: string;
  responseFile?: ResponseFile;

  showPendingPays: boolean;
  existsGuiMsg: boolean = false;
  guideMessage: string = '';
  pendAmount: Number;
  //purchItems: PurchDowloadsVO[];
  guide: GuideModel;
  folderId: string = "DIGITALITEMS";
  dnwGroup: string;
  imageToShow: any;
  showInternatColumns: boolean = false;
  device: string;
  lstItemsTrak: ItemsTrack[];
  selectedItemsTrak: ItemsTrack = null;
  filteredItemsTrack: ItemsTrack[] = [];
  listLanguage: ValuesVO[] = [];
  selectedLanguage: ValuesVO;
  selLang: string;
  listPurchItmDwn: any[] = [];


  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private authenticationService: AuthenticationService

  ) { }

  ngOnInit(): void {
    this.showPendingPays = false;
    this.existsGuiMsg = false;
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
          this.dnwGroup = params.dnwGroup;
          this.device = params.device;
          this.selLang = params.language;
        });
    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      } else {
        this.getSecurity();
      }
    }


    this.sortOptions = [
      { label: 'Price High to Low', value: '!price' },
      { label: 'Price Low to High', value: 'price' }
    ];
  }

  onSortChange(event) {
    const value = event.value;

    if (value.indexOf('!') === 0) {
      this.sortOrder = -1;
      this.sortField = value.substring(1, value.length);
    } else {
      this.sortOrder = 1;
      this.sortField = value;
    }
  }


  uploadItemPhoto(e, prod: ValuesVO) {
    this.imageSrc = '';
    this.selectedItem = prod;
    var file = e.currentFiles[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    this.selectedFileName = file.name;

    reader.readAsDataURL(file);
    reader.onload = () => {
      let array = (<string>reader.result).split(",");
      this.apiService.saveFileSantoApp({
        "nameFile": prod.valueId + "_" + this.selectedLanguage.valueId + ".jpg",
        "base64File": array[1],
        "folderId": this.folderId
      }).then(
        data => {
          this.getItemList();
          this.messageService.add({ severity: 'success', summary: 'Actualizacion', detail: 'Se agrego archivo correctamente', life: 3000 });
        }).catch(error => {
          console.error(error);
        });
    };
    
  }

  async saveFile(prod: ValuesVO) {
    //save file
    if (this.imageSrc != null) {
      await this.apiService.saveFileSantoApp(
        {
          "nameFile": prod.valueId + "_" + this.selectedLanguage.valueId + ".MP3" ,
          "base64File": this.imageSrc,
          "folderId": this.folderId
        }
      ).catch(error => {
          console.error(error);
      });
    }
  }


  getSecurity() {
    

    this.apiService.findSecurityById({ "id": this.token }).then(
      data => {
        this.security = data;

        if (this.security) {
          if (!this.selLang) {
            this.selLang = this.security.language;
          }
          this.getTranslatedLabels();
          this.getListSpkLangByStoreId();
          if (this.security.levelId == 'I' && (this.security.functionId == 'secre' || this.security.functionId == 'coord' || this.security.functionId == 'treas' || this.security.functionId == 'mate') || this.security.userId == 'administrador') {
            this.showInternatColumns = true;
          } else {
            this.showInternatColumns = false;
          }
        }
      });
  }
  getItemList() {

    if (this.security.userId == 'purivilargon'|| this.security.userId == 'lorenarodmed'|| this.security.userId == 'mercedessanfor'|| this.security.userId == 'josejuanrr' ||  this.security.userId == 'administrador') {
      this.apiService.listTranslatedItemsbyItemCat3(
        {
          "language": this.selectedLanguage.valueId,
          "itemCat3": "12"
        }
      ).then(
        data => {
          this.items = data;
          this.downloadImagesProduct();
        }
      );
    } else {
      this.apiService.getGuideItemsToPlay(
        {
          "guideId" : this.security.guideId,
          "language": this.selectedLanguage.valueId,
          "itemCat3": "12"
        }
      ).then(
        data => {
          this.findPurchItmDwnByGuideIdAvailable(data);
        }
      ).catch(error => {
        console.error(error);
      });
    }
    //this.getGuideBalance();
  }
  getGuideBalance() {
    let lstBal: BalanceVO[];
    this.pendAmount = 0;
    if (this.security.guideId) {
      this.apiService.getGuideBalance(
        {
          "guideId": this.security.guideId,
        }
      ).then(
        data => {
          lstBal = data;

          lstBal.forEach((element) => {
            if (element.concept.trim() == 'ADEUDO TOTAL') {

            }
          });
        }
      );
    }
  }
  /* getPurchasedItems() {

    this.apiService.getPurchItemsToDownload(
      {
        "language": this.security.language,
        "lstItemcat2": ["12"],
        "lstStr": [this.security.storeId]
      }
    ).then(
      data => {
        this.purchItems = data;

      }
    );
  }  */

  getGuide() {
    if (this.security.guideId != null) {
      this.apiService.getGuideById({ "guideId": this.security.guideId }).then(
        data => {
          this.guide = data;

        }).catch(error => {
          console.error(error);
        });
    }
  }

  selectRecord(selItemId: string) {
    if (selItemId == "0000") {
      this.router.navigate(['santov/itemsPersAlbums'], { queryParams: { itemId: selItemId, token: this.token, dnwGroup: this.dnwGroup, language: this.selectedLanguage.valueId, device: this.device } });
    } else {
      this.router.navigate(['santov/listItemsAlbum'], { queryParams: { itemId: selItemId, token: this.token, dnwGroup: this.dnwGroup, language: this.selectedLanguage.valueId, device: this.device } });
    }
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_select, this.lbl_type, this.lbl_photo, this.lbl_name, this.lbl_guide, this.lbl_there_are, this.lbl_item, this.lbl_search, this.lbl_track, this.lbl_go_Back, this.lbl_language]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_type = map.get(this.lbl_type);
        this.lbl_photo = map.get(this.lbl_photo);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_there_are = map.get(this.lbl_there_are);
        this.lbl_item = map.get(this.lbl_item);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_track = map.get(this.lbl_track);
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_language = map.get(this.lbl_language);
      });
  }
  getImageToShow(selItemId: string) {

    this.apiService.getFileSantoApp({
      "nameFile": selItemId + "_" + this.selectedLanguage.valueId + ".jpg",
      "folderId": this.folderId
    }).then(
      data => {
        let source = `data:image/jpg;base64,${data.base64File}`;
        let objIndex = this.items.findIndex((item => item.valueId == selItemId));
        this.items[objIndex].imageB64 = source;
        source = "";
      })
  }


  downloadImagesProduct() {
    const listItemsId = this.items.map(({ valueId }) => ({ valueId }));

    listItemsId.forEach((item) => {
      this.getImageToShow(item.valueId)
    }
    );
  }
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {

          if (data.code == 'R-0200') {
            this.getSecurity();

          } else {


          }
        },
        error => {

        });

  }
  filterItemsTrack(event) {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filtered: any[] = [];
    let query = event.query.toLowerCase();

    for (let i = 0; i < this.lstItemsTrak.length; i++) {
      let country = this.lstItemsTrak[i];
      if (country.name.toLowerCase().indexOf(query) != -1) {
        filtered.push(country);
      }
    }

    this.filteredItemsTrack = filtered;
  }
  listItemsTrackByItemLanguage() {
    this.lstItemsTrak = [];
    this.apiService.listItemsTrackByItemLanguage({
      "language": this.selectedLanguage.valueId
    }).then(
      data => {
        this.lstItemsTrak = data;


      });
  }
  redirectDtl(event) {
    if (this.selectedItemsTrak && this.selectedItemsTrak.id) {
      this.router.navigate(['santov/itemTracksDwn'], { queryParams: { itemId: this.selectedItemsTrak.id.itemId, albumId: this.selectedItemsTrak.id.albumId, token: this.token, dnwGroup: this.dnwGroup, device: this.device } });
    }
  }
  getSecurityOption(listPassItms: ValuesVO[]) {
    let genMsg: GenericMessageVO;
    this.apiService.checkTransactionAccess({
      "token": this.token,
      "transaction": this.transactionId
    })
      .then(
        response => {
          genMsg = response;
          this.items = [];
          if (genMsg && genMsg.code == 0) {
            listPassItms.forEach(element => {
              this.items.push(element);
            });
            this.listItemsTrackByItemLanguage();
            this.downloadImagesProduct();

            this.getGuide();

          } else {
            this.messageService.add({ severity: 'error', summary: 'No tiene acceso / No Access / Não tem acesso', detail: "Usted no tiene audios disponibles, contacte a su tesorero / You do not have audios available, contact your treasurer / Você não tem áudios disponíveis, entre em contato com seu tesoureiro", life: 300000 });
          }
        }
      )

  }
  goBack() {
    window.close();
  }
  getListSpkLangByStoreId() {
    this.selectedLanguage = {};
    this.apiService.getListSpkLangByStoreId({
      "language": this.security.language,
      "storeId": this.security.storeId
    }).then(
      data => {
        this.listLanguage = data;

        this.listLanguage.forEach((element) => {
          if (!this.selLang) {
            this.selLang = element.valueId;
          }
          if (element.valueId.trim() == this.selLang) {
            this.selectedLanguage.value = element.value;
            this.selectedLanguage.valueId = element.valueId;
          }
        });
        if (!this.selectedLanguage.value) {
          this.selectedLanguage = this.listLanguage[0];
        }
        this.getItemList();

      });
  }
  findPurchItmDwnByGuideIdAvailable(listPassItms: ValuesVO[]) {
    if (this.security.guideId) {
      this.apiService.findPurchItmDwnByGuideIdAvailable({
        "language": this.selectedLanguage.valueId,
        "guideId": this.security.guideId
      }).then(
        data => {
          this.listPurchItmDwn = data;
          if (this.listPurchItmDwn) {

            let itemsTemp1: ValuesVO[];
            let itemsTemp2: ValuesVO[] = [];
            this.listPurchItmDwn.forEach((element) => {
              itemsTemp1 = listPassItms.filter(s => s.valueId === element.id.itemId);
              itemsTemp1.forEach((element) => {
                itemsTemp2.push(element);
              });
            });
            this.items = [];
            itemsTemp2.forEach((element) => {
              this.items.push(element);
            });

            if (this.items && this.items.length > 0 && this.security.levelId != Constants.ZONE_LEVELID && this.security.levelId != Constants.INTNAL_LEVELID) {
              this.downloadImagesProduct();
            } else {
              this.getSecurityOption(listPassItms);

            }
          } else {
            this.getSecurityOption(listPassItms);

          }
        });
    } else {

      this.getSecurityOption(listPassItms);
    }

  }
}
